import { Client } from '@/utilities/api/Client';
import { QueryUtil } from '@/utilities/Query';
import { ReportEndpoint } from '@api/endpoints';

export class ReportApi {
  static create (
    retailerId: string,
    body: ReportEndpoint.Create.Request,
  ): Promise<ReportEndpoint.Create.Response> {
    return Client(`retailer/${retailerId}/reports`, {
      method: 'POST',
      body,
    });
  }

  static list (
    retailerId: string,
    query: ReportEndpoint.List.QueryParams,
  ): Promise<ReportEndpoint.List.Response> {
    return Client(`retailer/${retailerId}/reports?${QueryUtil.stringify(query)}`);
  }

  static get (retailerId: string, reportId: string): Promise<ReportEndpoint.Get.Response> {
    return Client(`retailer/${retailerId}/reports/${reportId}`);
  }

  static getDownloadUrl (
    retailerId: string,
    reportId: string,
  ): Promise<ReportEndpoint.GetDownloadUrl.Response> {
    return Client(`retailer/${retailerId}/reports/${reportId}/download-url`);
  }
}
